import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function Strike(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    React.createElement("span", _extends({}, props.dataAttributes, {
      style: {
        textDecoration: 'line-through'
      }
    }), props.children)
  );
}